import {
  Component,
  OnInit,
  Input,
  AfterViewInit,
  ChangeDetectorRef, Output, EventEmitter
} from '@angular/core';
import { Principal } from '../../../models/film/principal.model';
import {
  FormGroup,
  FormBuilder,
  AbstractControl,
  ValidationErrors,
  Validators
} from '@angular/forms';
import { Subscription ,  Subject } from 'rxjs';
import {Application} from '../../../models/film/film-application.model';
import {FormValidationService} from '../../../../form/services/validation.service';
declare var $;
declare type ModalMode = 'Add' | 'Edit';

@Component({
  selector: 'fl-principals',
  templateUrl: './principals.component.html',
  styleUrls: ['./principals.component.css']
})
export class PrincipalsComponent implements OnInit {
  @Input() principals: Principal[];
  roles: string[];
  principalForm: FormGroup;
  @Input() readonly: boolean;
  private formGroupSubscription: Subscription;
  mode: ModalMode;
  selectedPrincipal: Principal;
  selectedPrincipalIndex: number;
  @Input() application: Application;

  hasPrincipals= false;

  principalsForm: FormGroup;
  principalRequirementsForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private validationService: FormValidationService
  ) {
    this.principalForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      middleInitial: [''],
      role: ['', Validators.required]
    });
  }

  delete(index: number) {
    // Remove principal at particular index
    const removedPrincipals = this.principals.splice(index, 1);
    this.validateRequirements();
  }

  ngOnInit() {

    $('#principalModal').on('shown.bs.modal', e =>
      $('[data-toggle="tooltip"]').tooltip()
    );

    // Register modal events
    $('#principalModal').on('hidden.bs.modal', e => $('button:focus').blur());

    this.principalsForm = this.fb.group({
      name: ['', Validators.required],
      relationship: ['', Validators.required],
      transactionAmount: ['', Validators.required]
    });

    this.principalRequirementsForm = this.fb.group({
      hasPrincipals: [null, Validators.pattern('true')]
    });

    this.validationService.form.setControl(
      'principalRequirementsForm',
      this.principalRequirementsForm
    );

    this.validateRequirements();
  }

  validateRequirements() {
    this.hasPrincipals = this.principals.length > 0;

    this.principalRequirementsForm.get('hasPrincipals').setValue(this.hasPrincipals);
  }

  save() {
    // Transfer data from form model to data model
    Object.assign(this.selectedPrincipal, this.principalForm.value);

    if (this.mode === 'Add') {
      // Add new principal
      this.principals.push(this.selectedPrincipal);
    }
    this.validateRequirements();
  }
  select(modalMode: ModalMode, index?: number) {
    const that = this;
    const principal =
      index !== undefined && index != null
        ? this.principals[index]
        : new Principal().init();
    this.mode = modalMode;
    this.selectedPrincipal = principal;
    this.selectedPrincipalIndex = index;
    this.validateRequirements();
  }
}
